export default __webpack_public_path__ + "static/media/minus.81e41f12.svg";